<template>
    <div class="about-main">
      <div class="about-top">
          <img src="../assets/abtus_banner.png" style="max-width:100%;" width="100%" />
      </div>
      <div class="about-content">
          <div class="cont-1" >
            <div class="image-one">
             <img src="../assets/abtus_bg_1.png" style="width:490px;height:340"  /> 
            </div>
              <p class="text-one" style="margin-top: 0px;" align="left">
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;北京中汇豪泰电子商务有限公司，是一家以团膳互联网+模式为企业员工福利提供综合解决方案的专业的服务商。依托于“互联网+”的创新模式，为客户方的企业员工提供更加便捷的就餐服务及积分换购服务，同时扩展点餐消费及企业福利的覆盖范围。公司融合系统开发、在线点餐、平台运营、供应链服务等四大基础核心服务，为团膳餐饮企业提供一站式运营解决方案。
              </p>
              <p class="text-one" style="" align="left">
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;公司总部立足于北京，积极向全国地区拓展，目前公司自主研发的团膳企业平台综合管理系统--中汇商联系统已于2017年11月正式上线启用，该系统主要帮助团膳餐饮企业、企业餐厅、企业员工、平台供应商进行有效的业务管理。
              </p>
          </div>
          <br style="clear:both;" />
          <div class="cont-2" >
            <div class="image-two">
             <img src="../assets/abtus_bg_2.png" style="width:450px;height:360"  /> 
            </div>
            <div>
              <p class="text-one" style="margin-top: 0px;" align="left">
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;公司已与上海锦歌企业管理服务有限公司开展了全面合作运营，无论是在为合作方的管理水平提升还是在综合收益改善方面都取得了良好的效果。现阶段公司已与爱玛客服务产业（中国）有限公司达成了全面战略合作协议，“爱玛客”被《财富》杂志评选为2016年全球最受尊敬企业，在21个国家拥有270,000名员工，在中国的服务已经覆盖了33个城市，250多家企业。此番合作必将为中汇豪泰团膳互联网+生态国际化打下坚实基础。
            </p>
            <p align="left" style="padding-top:55px">
              “潮平两岸阔，风正一帆悬”。如今的中汇豪泰正以国际化的视野，坚实自信的步伐，将事业不断推向前进。
            </p>
            </div>
          </div>
          <br style="clear:both;" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'about',
  data () {
    return {
      bg_images: [require('../assets/bg_banner.jpeg')],
      cb_images: [require('../assets/logo_jt.png'),require('../assets/logo_jt.png'),require('../assets/logo_jt.png')],
      headerFixed:true,
      //banners: [ '/1.jpg', '/2.jpg', '/3.jpg' ],
      bannert:'/bg_banner.jpeg',
      height:"400px",
      cb_height:"400px",
      cb_carousel_height:"300px",
      horizontal:false,
      vertical:true,
      menuDisplay:'none',
      activeIndex:"1",
    }
  },
  methods: {
    onResize(){
      var width = document.documentElement.clientWidth;
      console.log(width);
      this.setCarouselHeight(width)
      this.setHeaderLayout(width)
    },
    setHeaderLayout(width){
      var cb_c_h = "340px";
      if (width <=1200) {
        this.vertical=true;
        this.horizontal=false;

      } else {
        this.horizontal=true;
        this.vertical=false;
      }

      if (width >= 1320) {
        this.cb_carousel_height="380px";
      } else if (width <1320) {
        this.cb_carousel_height="340px";
      }
    },
    setCarouselHeight(width){
      this.height = (width / 3.4).toString()+"px";
      this.cb_height = (width / 3).toString()+"px";
      // this.cb_carousel_height = (width /3)* (3/4).toString() + "px";
    },
    handleOpen(index, path){
      console.log(index, path)
    },

    handleClose(index, path){
      console.log(index, path)
    },
    handlerClick(){
      console.log("wft")
    }
  },
  mounted(){
    this.onResize();
    window.addEventListener('resize', this.onResize);

    console.log(">>>>>>index wft")
  }
}
</script>

<style>
.about-main {
  margin-top: 60px;
  padding-bottom: 120px;
  position: relative;
}
.about-content {
  height: auto;
  width: 85%;
  text-align: center;
  margin:0 auto;
}

@media screen and (min-width: 1368px) {
  .about-content {
    width: 70%;
  }
}
@media screen and (min-width: 1564px) {
  .about-content {
    width: 60%;
  }
}
.cont-1 {
  
  padding-top: 90px;
}
.cont-2 {
  padding-top: 70px;

}
.image-one {
  float:left;
  margin-right: 52px;
}
.image-two {
  float:right;
  margin-left: 52px;
}
.about-main p {
  /*margin-top: 0px;*/
  font-size: 16px;
  color: #666666;
  padding-left: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/About.vue